import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import axios from 'axios'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { Link, useNavigate } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import matchType, { SPORTS_TYPE } from '../helper/index'
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Swal from 'sweetalert2'
import { GET_SCORE_CARD, GLOBAL, JOIN_SLOT_HOLD, MATCHLIST, MATCHLISTPUBSUB, SET_TEAM_DETAILS } from '../constant/endpoint';
import { useStyles } from '../constant/constant';
import { CircularProgress, Dialog, Grid, TextField, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';

export default function BotMatchList({ gst }) {
    const navigate = useNavigate();
    const [value, setValue] = React.useState('1');
    const [contextName, setContextName] = React.useState("UPCOMING")
    const [listData, setListData] = React.useState([]);
    const [defaultPage, setDefaultPage] = React.useState(1)
    const [totalPage, settotalPage] = React.useState(2)
    const [loading, setLoading] = React.useState(false)
    const [joinSlot, setJoinSlot] = React.useState("");
    const [sport, setSport] = React.useState(1)
    const [toggleScoreCard, setToggleScoreCard] = React.useState({
        isOpen: false,
        match_id: "",
        series_id: ""
    })
    const classes = useStyles();
    const user = useSelector(state => state.loginSlice)
    const userProfile = !isEmpty(user?.token) ? jwtDecode(user?.token) : { accessLevel: 0 }

    const handleChange = (event, newValue) => {
        setContextName(event.target.innerText)
        setValue(newValue)
        setDefaultPage(1)
        getMatchList(event.target.innerText.toLowerCase(), 1, sport)
    };
    const handleSportChange = (event, newValue) => {
        setSport(newValue)
        setDefaultPage(1)
        getMatchList(contextName.toLowerCase(), 1, newValue)
    }
    const handlePagination = async (e, p) => {
        let contentType = contextName.trim()
        await getMatchList(contentType.toLowerCase(), p, sport)
        setDefaultPage(p)
    }
    const getMatchList = async (status = gst ? 'result' : "upcoming", pageNumber = 1, sport = 1) => {
        setLoading(true)
        const response = await axios.get(`${MATCHLIST}&sport=${sport}`.replace(':status', status.trim() === 'live' ? 'running' : status.trim() === 'result pending' ? 'cancelled' : status.trim() === 'result' ? 'completed' : status.trim()).replace(':default', pageNumber))
        setLoading(false)
        if (response?.data?.status) {
            setListData(response?.data?.data.upcoming_match)
            settotalPage(response?.data?.data?.paginated_data?.totalPage) 
        }
    }
    const getJoinSlotHold = async () => {
        const response = await axios.get(`${JOIN_SLOT_HOLD}`)
        if (response?.data?.data) {
            setJoinSlot(response.data.data)  
        }
    }
    const setJoinSlotHold = async () => {
        const response = await axios.post(`${JOIN_SLOT_HOLD}`, {slots:joinSlot})
        if (response?.data?.data && response?.data?.data === "OK") {
            setJoinSlot(joinSlot)  
            Swal.fire('Updated Successfully')
        }
    }


    const globalFiles = async (e, data) => {
        var formData = new FormData()
        formData.append('files', e.target.files[0]);
        formData.append('match_id', data.match_id);
        const response = await axios.post(GLOBAL.replace(':match_id', data.match_id), formData)
        if (response.data.status === 'success') {
            Swal.fire('Global Image Upload Successfully')
            let contentType = contextName.trim()
            await getMatchList(contentType.toLowerCase(), defaultPage, sport)
        } else {
            alert('something went wrong')
        }
    }

    React.useEffect(() => {
        getMatchList()
        getJoinSlotHold()
    }, [])
    return (
        <>
            <Box sx={{ width: '100%', typography: 'body1' }} style={{ marginTop: "100px" }}>
                <div style={{display:"flex", justifyContent:"end", paddingRight:"20px"}}>
                    <TextField size='small' type='number' value={joinSlot} onChange={(e) => setJoinSlot(e.target.value)}
                         onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                setJoinSlotHold();
                            }
                          }}
                    ></TextField>
                    {/* <Button on={setJoinSlotHold}>Slot Update</Button> */}
                </div>
            <TabContext value={value}>
                {!gst && <TabContext value={sport}><Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleSportChange} aria-label="lab API tabs example" style={{ display: "flex !important", justifyContent: "space-around !important" }} >
                        {
                            SPORTS_TYPE.map((data, index) =>
                                <Tab label={data.name} key={index} value={data.sport} title={data.name} />
                            )
                        }
                    </TabList>
                </Box></TabContext>}
                {!gst && <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example" style={{ display: "flex !important", justifyContent: "space-around !important" }} >
                        {
                            matchType.map((data, index) =>
                                <Tab label={data === 'running' ? 'Live' : data === 'cancelled' ? 'Result Pending' : data === 'completed' ? 'Result' : data} key={index} value={(index + 1).toString()} title={(index + 1).toString()} />
                            )
                        }
                    </TabList>
                </Box>}
                <TabPanel value={value}>
                    <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                        <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center"> Image</TableCell>
                                    <TableCell align="center">Match Id</TableCell>
                                    <TableCell align="center">Team vs Team</TableCell>
                                    <TableCell align="left">Series</TableCell>
                                    <TableCell align="left">Time Date</TableCell>
                                    <TableCell align="left">Type</TableCell>
                                   
                                    {!gst && <TableCell align="center">Action</TableCell>}
                                </TableRow>
                            </TableHead>
                                <TableBody>
                                {listData.length > 0 ? listData?.map((data) => (
                                    <TableRow
                                        key={data.name}
                                    >

                                        <TableCell size='small' style={{ width: '10%' }}>
                                            <img src={data.prediction_image} style={{ width: '85px' }} alt='' />
                                            <input
                                                style={{ width: '90px' }}
                                                accept="image/*"
                                                id="contained-button-file"
                                                multiple
                                                type="file"
                                                onChange={(e) => globalFiles(e, data)}
                                            />
                                        </TableCell>
                                        <TableCell>{data.match_id}</TableCell>
                                        <TableCell component="th" scope="row">
                                            {data.local_team_name} Vs {data.visitor_team_name}
                                        </TableCell>
                                        <TableCell>{data.series_name}</TableCell>
                                        <TableCell align="left">{data.star_time}{' '}{data.star_date}</TableCell>
                                        <TableCell align="left">{data.type}</TableCell>
                                       
                                        {!gst && <TableCell align="left">
                                            {data.match_status === 'Cancelled' ? <h4 style={{ color: "red", margin: "0px 0px", textAlign: "center" }}>Cancelled Match</h4> : ''}
                                            {
                                                // data.total_contest > 0 ?
                                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                                    <InputLabel id="demo-simple-select-filled-label">Prediction</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-filled-label"
                                                        key={data.match_id}
                                                    >

                                                        <MenuItem value={''}>Select Option</MenuItem>
                                                        <MenuItem value={3} sx={{ 'padding': 0 }}><Link to={`/matchlist/trading-bot/${data.match_id}/${data.series_id}/${data.sport}`} style={{ display: 'block', width: '100%', padding: 10 }}>Trading</Link></MenuItem>
                                                    </Select>
                                                </FormControl>
                                            }
                                        </TableCell>}
                                    </TableRow>

                                )) : loading ? 
                                <Box sx={{
                                    position: 'fixed',
                                    top: 0,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    zIndex: 9999, // Ensure it stays above other elements
                                    paddingTop: '30%', // Space from top of the page
                                }}>
                                    <CircularProgress></CircularProgress>
                                </Box> 
                                 : <TableCell colSpan={12} ><h3 style={{ textAlign: "center" }}>No Data Found</h3></TableCell>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Stack spacing={2}>
                        {
                            listData.length > 0 &&
                            <Pagination count={totalPage} page={defaultPage} color="primary" onChange={handlePagination} />
                        }
                    </Stack>
                </TabPanel>
                </TabContext>
            </Box>
        </>
    );
}
